import { useMemo } from "react";

const useFormat = (viewCount, publishedAt) => {
  const formattedViews = useMemo(() => {
    if (viewCount >= 1_000_000_000) {
      return (viewCount / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B"; // Billions
    } else if (viewCount >= 1_000_000) {
      return (viewCount / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M"; // Millions
    } else if (viewCount >= 1_000) {
      return (viewCount / 1_000).toFixed(1).replace(/\.0$/, "") + "K"; // Thousands
    } else {
      return viewCount.toString(); // Less than 1,000, just return the number
    }
  }, [viewCount]);
  const timeAgo = useMemo(() => {
    const currentTime = new Date();
    const timeDiff = currentTime - new Date(publishedAt); // Time difference in milliseconds

    const seconds = Math.floor(timeDiff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return days === 1 ? "1 day ago" : `${days} days ago`;
    } else if (hours > 0) {
      return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
    } else if (minutes > 0) {
      return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
    } else {
      return seconds === 1 ? "1 second ago" : `${seconds} seconds ago`;
    }
  }, [publishedAt]);
  return { formattedViews, timeAgo };
};
export default useFormat;
